export enum TotalTypes {
    SUBTOTAL = 'subtotal',
    FEE = 'platform_fee',
    GRAND = 'grand_total',
    OFFER_ITEMS = 'total_content',
    ADDITIONAL_ITEMS = 'total_items',
}
